/* eslint-disable react/prop-types */
import Box from '@mui/material/Box'
import Paper from '@mui/material/Paper'
import Table from '@mui/material/Table'
import TableHead from '@mui/material/TableHead'
import TableBody from '@mui/material/TableBody'
import TableRow from '@mui/material/TableRow'
import TableCell from '@mui/material/TableCell'
import IconButton from '@mui/material/IconButton'
import Chip from '@mui/material/Chip'
import MoreVertIcon from '@mui/icons-material/MoreVert'
import { PLAN_LABELS, PLAN_COLORS, sortPlans } from '../../../shared/constants/planLabels'
import { USAGE_TYPE_LABELS, USAGE_TYPE_COLORS } from '../featureToggleConstants'

function FeatureToggleTable({ features, isLoading, onOpenMenu }) {
  return (
    <Paper variant="outlined">
      <Table>
        <TableHead>
          <TableRow>
            <TableCell>
              <strong>Nome</strong>
            </TableCell>
            <TableCell>
              <strong>Descrição</strong>
            </TableCell>
            <TableCell>
              <strong>Uso</strong>
            </TableCell>
            <TableCell>
              <strong>Planos ativos</strong>
            </TableCell>
            <TableCell>
              <strong>Qtd. tenants</strong>
            </TableCell>
            <TableCell>
              <strong>Ações</strong>
            </TableCell>
          </TableRow>
        </TableHead>
        <TableBody>
          {features.map((item) => (
            <TableRow key={item.name}>
              <TableCell>{item.name}</TableCell>
              <TableCell>{item.description}</TableCell>
              <TableCell>
                <Chip
                  label={USAGE_TYPE_LABELS[item.usageType] ?? item.usageType}
                  color={USAGE_TYPE_COLORS[item.usageType] ?? 'default'}
                  size="small"
                />
              </TableCell>
              <TableCell>
                <Box sx={{ display: 'flex', flexWrap: 'wrap', gap: 0.5 }}>
                  {sortPlans(item.plans ?? []).map((plan) => (
                    <Chip
                      key={plan}
                      label={PLAN_LABELS[plan] ?? plan}
                      size="small"
                      sx={PLAN_COLORS[plan] && { backgroundColor: PLAN_COLORS[plan].background, color: PLAN_COLORS[plan].color }}
                    />
                  ))}
                </Box>
              </TableCell>
              <TableCell>{item.tenantsCount}</TableCell>
              <TableCell>
                <IconButton
                  size="small"
                  aria-label={`Ações: ${item.name}`}
                  onClick={(event) => onOpenMenu(event, item)}
                >
                  <MoreVertIcon fontSize="small" />
                </IconButton>
              </TableCell>
            </TableRow>
          ))}
          {!isLoading && features.length === 0 && (
            <TableRow>
              <TableCell colSpan={6}>Nenhuma feature encontrada.</TableCell>
            </TableRow>
          )}
        </TableBody>
      </Table>
    </Paper>
  )
}

export default FeatureToggleTable
